import { render, staticRenderFns } from "./SchoolLeaveTableControl.vue?vue&type=template&id=6715bc88&scoped=true&"
import script from "./SchoolLeaveTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715bc88",
  null
  
)

export default component.exports